import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Popover } from '@headlessui/react';
import { ChevronDownIcon, XMarkIcon } from '@heroicons/react/24/solid';
import { usePopper } from 'react-popper';
import fonts from 'styles/typography.module.css';

interface Props {
  label: string;
  children?:
    | React.ReactNode
    | ((bag: {
        open: boolean;
        close: (
          focusableElement?: HTMLElement | React.MutableRefObject<HTMLElement | null>
        ) => void;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      }) => React.ReactElement<any, string | React.JSXElementConstructor<any>>);
  count?: number;
  clear?: () => void;
  /** Optional additional classes applied to the floating panel */
  className?: string;
}

export const FilterDropdown: React.FC<Props> = (props) => {
  const { label, children, count, clear, className } = props;

  const [referenceElement, setReferenceElement] = React.useState<HTMLButtonElement | null>();
  const [popperElement, setPopperElement] = React.useState<HTMLDivElement | null>();
  const { styles, attributes } = usePopper(referenceElement, popperElement);

  return (
    <Popover.Group>
      <Popover className="relative">
        {({ open }) => (
          <>
            <Popover.Button ref={setReferenceElement} className="outline-none">
              <div
                className={`flex space-x-2 hover:underline font-medium px-2 py-2 rounded-sm
              ${open ? 'text-gray-900' : 'text-gray-500'} 
              ${count ? 'bg-blue-100 !text-blue-900' : ''} `}
              >
                {count && clear ? (
                  <XMarkIcon
                    onClick={(e) => {
                      e.stopPropagation();
                      clear();
                    }}
                    className="w-4"
                  />
                ) : null}
                <h4>{label}</h4>
                <ChevronDownIcon
                  color={open || count ? 'text-gray-900' : 'text-gray-500'}
                  className={`shrink-0 w-4 transition ${open ? 'rotate-180 transform' : ''} `}
                />
              </div>
            </Popover.Button>
            {ReactDOM.createPortal(
              <Popover.Panel
                ref={setPopperElement}
                style={styles.popper}
                className={`${fonts.font} bg-white border border-gray-300 rounded shadow-md z-[9999] ${className}`}
                {...attributes.popper}
                // onClick={(e: any) => {
                //   e.preventDefault();
                //   e.stopPropagation();
                // }}
              >
                {children}
              </Popover.Panel>,
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              document.querySelector('#root')!
            )}
          </>
        )}
      </Popover>
    </Popover.Group>
  );
};
FilterDropdown.displayName = 'FilterDropdown';
